import { query } from 'src/utils/request';

// 查看采购需求收集表申报列表
export const requestList = async data => {
  return query('/zlb/api/expense/purchase/manage/declare/page', {
    data,
    method: 'post',
  });
};

// 查看采购需求收集表详情
export const viewPurchaseDetail = async params => {
  return query('/zlb/api/expense/purchase/manage/purchaseCollect/query', {
    params,
  });
};

export const queryPurchaseDirectory = async params => {
  return query('/zlb/api/expense/purchase/manage/queryPurchaseDirectory', {
    params,
  });
};

// 采购需求申报保存
export const purchaseDeclareSave = async data => {
  return query('/zlb/api/expense/purchase/manage/declare/save', {
    data,
    method: 'post',
  });
};

// 采购需求商品删除
export const purchaseDeclareDelete = async data => {
  return query('/zlb/api/expense/purchase/manage/declare/delete', {
    data,
    method: 'post',
  });
};
